/* unplugin-vue-components disabled */import script from "./RecommendAbout.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecommendAbout.vue?vue&type=script&lang=ts&setup=true"

import "./RecommendAbout.vue?vue&type=style&index=0&id=75f8e310&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75f8e310"]])

export default __exports__